<div class="app-confirmation-dialog app-loading-host" [attr.data-testId]="testIds.container">
  <app-loading-indicator [loading]="running" [testId]="testIds.progress"></app-loading-indicator>

  <div class="app-confirmation-dialog__header" [attr.data-testId]="testIds.title">
    {{ options.title }}
  </div>

  <div class="app-confirmation-dialog__body">
    <div [attr.data-testId]="testIds.message">
      <p *ngFor="let paragraph of paragraphs" class="app-confirmation-dialog__paragraph">
        <ng-container *ngFor="let part of paragraph" [ngSwitch]="part.kind">
          <strong *ngSwitchCase="'strong'" class="app-confirmation-dialog__strong">{{ part.text }}</strong>
          <span *ngSwitchCase="'badge'" class="app-confirmation-dialog__badge">{{ part.text }}</span>
          <ng-container *ngSwitchDefault>{{ part.text }}</ng-container>
        </ng-container>
      </p>
    </div>

    <div *ngIf="options.warning" class="app-confirmation-dialog__warning">
      <mat-icon class="app-confirmation-dialog__warning-icon">warning</mat-icon>
      <p class="app-confirmation-dialog__warning-text" [attr.data-testId]="testIds.warning">
        {{ options.warning }}
      </p>
    </div>
  </div>

  <div class="app-confirmation-dialog__footer">
    <div class="app-confirmation-dialog__actions">
      <button
        *ngIf="!options.hideCancel"
        type="button"
        class="app-confirmation-dialog__actions-button transparent"
        [disabled]="running"
        (click)="cancelled.emit()"
        [attr.data-testId]="testIds.cancel"
      >
        {{ options.cancelLabel || 'Cancel' }}
      </button>
      <button
        type="button"
        class="app-confirmation-dialog__actions-button"
        [class.destructive]="options.destructive"
        [disabled]="running"
        (click)="confirmed.emit()"
        [attr.data-testId]="testIds.confirm"
      >
        {{ options.confirmLabel }}
      </button>
    </div>
  </div>
</div>
